import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ActionsGroup from '../../../common/ui/ItemActions';
import Loader from '../../../common/ui/Loader';

export default class WhereToReport extends Component {
  static propTypes = {
    where_to_report: PropTypes.string,
    showEditIcons: PropTypes.bool.isRequired,
    editJob: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      isLoading: false,
      isEditing: false,
      where_to_report: props.where_to_report
    };
  }

  startEditing = () => {
    this.setState({ isEditing: true });
  };

  cancelEditing = () => {
    this.setState({ where_to_report: this.props.where_to_report, isEditing: false });
  };

  handleChange = e => this.setState({ where_to_report: e.target.value });

  submitEditing = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    this.props.editJob({ where_to_report: this.state.where_to_report || null }).then(() => {
      this.setState({ isLoading: false, isEditing: false });
    });
  };

  render () {
    const { isEditing, isLoading, where_to_report } = this.state;
    const { showEditIcons } = this.props;
    return (
      <section className='full-width'>
        <form onSubmit={this.submitEditing}>
          <div className='d-flex justify-content-between mb-2'>
            <h4 className='job-details-section-header'>Where to report</h4>
            { showEditIcons && !isLoading && (
              <ActionsGroup
                isEditing={isEditing}
                enterEditMode={this.startEditing}
                exitEditMode={this.cancelEditing}
              />
            )}
          </div>
          { isLoading ? <div className='loader-wrapper'><Loader /></div> : (
            <Fragment>
              { isEditing ? (
                <textarea
                  className='input input-textarea'
                  name='where_to_report'
                  placeholder='Type where to report'
                  value={where_to_report || ''}
                  onChange={this.handleChange}
                />
              ) : (
                <p className='text'>{where_to_report}</p>
              )}
            </Fragment>
          )}
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/WhereToReport.js